<template>
  <div id="data-list-list-view" class="data-list-container vs-con-loading__container">
    <vx-card>
      <template slot="no-body">
        <div class="p-2">
          <!--<vs-switch color="success" v-model="active_geofence">-->
          <!--<span slot="on">Geofence On </span>-->
          <!--<span slot="off">Geofence Off </span>-->
          <!--</vs-switch>-->
          <div class="vx-row">
            <vs-col vs-w="4">
              <VueCtkDateTimePicker :only-date="true" no-button-now label="Select Trip Date" :format="'YYYY-MM-DD'"
                :formatted="'YYYY-MM-DD'" v-model="date" />
            </vs-col>
            <vs-col vs-w="2" class="pl-0">
              <vs-select class="selectTrip w-full" v-model="trip">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in trips" />
              </vs-select>
            </vs-col>
            <vs-col vs-w="2">
              <vs-button v-if="!calculated" type="gradient" class="shadow btn-load-1 vs-con-loading__container"
                color="#d23030" gradient-color-secondary="#f89595" @click="viewRoute()">View Timeline
              </vs-button>
              <vs-button v-else type="gradient" class="shadow btn-load-1 vs-con-loading__container" color="#d23030"
                gradient-color-secondary="#f89595" @click="reroute()">Reroute Timeline
              </vs-button>
            </vs-col>
            <vs-col vs-w="4" class="text-right">
              <vs-button type="gradient" class="shadow btn-download-1 vs-con-loading__container" color="#922e2e"
                gradient-color-secondary="#ff4e4e" @click="download_data()">Download Data
              </vs-button>
            </vs-col>
          </div>
        </div>
        <div id="loading-container" class="w-full"></div>

        <vs-divider style="margin: 0" />
        <vs-row vs-w="12">
          <div class="heights" style="position: relative">
            <div v-if="overlay" style="
                z-index: 4;
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.87);
              ">
              <p style="
                  color: #000;
                  font-size: 17px;
                  font-weight: bold;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                ">
                Select data to be shown
              </p>
            </div>
            <span></span>
            <div class="legenda">
              <div>
                <div class="buletan item"></div>
                <div>Start/End Point</div>
              </div>
              <div>
                <div class="buletan biru"></div>
                <div>Way Point</div>
              </div>
              <div>
                <div class="buletan merah"></div>
                <div>Event Point</div>
              </div>
            </div>
            <div class="control-side">
              <vs-button v-if="
                getRolePermission().vehicle_details.periodic_track.show_graph
              " :color="`${isGraphVisible ? 'danger' : 'white'}`" type="filled" class="p-3"
                @click="isGraphVisible = !isGraphVisible">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M14.9435 21.088V3.91199C14.9435 3.3597 14.4958 2.91199 13.9435 2.91199H9.88528C9.333 2.91199 8.88528 3.3597 8.88528 3.91199V21.088M14.9435 21.088L14.9419 10.7681C14.9418 10.2158 15.3896 9.76799 15.9419 9.76799H20C20.5523 9.76799 21 10.2157 21 10.768V20.088C21 20.6403 20.5523 21.088 20 21.088H14.9435ZM14.9435 21.088H8.88528M8.88528 21.088V16.088C8.88528 15.5357 8.43757 15.088 7.88528 15.088H4C3.44771 15.088 3 15.5357 3 16.088V20.088C3 20.6403 3.44771 21.088 4 21.088H8.88528Z"
                    :stroke="isGraphVisible ? 'white' : '#EE6D6D'" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </vs-button>
            </div>
            <div class="control-place">
              <div class="controls">
                <div class="control-btn" @click="restartPlay()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="RefreshCwIcon"></feather-icon>
                </div>
                <div class="control-btn" @click="slower()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="RewindIcon"></feather-icon>
                </div>
                <div class="control-btn" v-if="!isResume" @click="resumeAnimation()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="PlayIcon"></feather-icon>
                </div>
                <div v-if="isResume" class="control-btn" @click="pauseAnimation()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="PauseIcon"></feather-icon>
                </div>
                <div class="control-btn" @click="faster()">
                  <feather-icon svgClasses="h-4 w-4" class="cursor-pointer" icon="FastForwardIcon"></feather-icon>
                </div>
                <div class="bg-white rounded-full py-2 px-3 ml-1">
                  {{ Number(1 / (this.baseSpeed / 8)).toFixed(2) }}x
                </div>
              </div>
              <!-- <div
                v-if="this.isGraphVisible"
                id="chartResizeKnob"
                class="bg-white w-full justify-center items-center flex grab">
                <feather-icon
                  svgClasses="h-6 w-6"
                  icon="MinusIcon"></feather-icon>
              </div> -->
              <!-- previous graph location -->
              <div class="px-2 py-1 rounded-lg bg-white">
                <range-slider v-if="this.selectedLocation" class="slider w-full control-slider" min="0"
                  :max="sliderMaxValue" step="1" v-model="sliderValue">
                  <template v-slot:knob>
                    <div @mouseenter="isKnobHover = true" @mouseleave="isKnobHover = false">
                      <vs-button class="p-0"></vs-button>
                      <div :class="isKnobHover ? '' : 'hidden'" style="
                          top: -45px;
                          left: -40px;
                          position: absolute;
                          padding: 5px;
                          background-color: #ff1111;
                          color: white;
                          border-radius: 10px;
                          font-size: 12px;
                          width: 100px;
                          text-align: center;
                        ">
                        {{ selectedLocation.device_time }}
                      </div>
                    </div>
                  </template>
                </range-slider>
              </div>
            </div>
            <GmapMap v-if="showMap" ref="mapRef" :center="center" class="playback-map" style="width: 100%; height: 100%"
              :options="{
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
              }">
              <gmap-info-window v-if="selectedLocation !== null" :options="{ pixelOffset: { width: 0, height: 0 } }"
                :position="{
                  lat: selectedLocation.latitude,
                  lng: selectedLocation.longitude,
                }" :opened="infoBoxOpen" @closeclick="infoBoxOpen = false">
                <InfoWindow :selectedLocation="selectedLocation" />
              </gmap-info-window>
              <gmap-info-window v-if="selectedPoi !== null" :options="{ pixelOffset: { width: 0, height: 0 } }"
                :position="{
                  lat: selectedPoi.latitude,
                  lng: selectedPoi.longitude,
                }" :opened="infoBoxPoiOpen" @closeclick="infoBoxPoiOpen = false">
                <div>
                  <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                    <!-- <h5>POI Detail</h5> -->
                    <table style="width: 100%">
                      <tr>
                        <td>POI Name</td>
                        <td>:</td>
                        <td>
                          <strong>{{ selectedPoi.poi_name }}</strong>
                        </td>
                      </tr>
                    </table>
                  </vs-col>
                </div>
                <!-- <InfoWindow :selectedPoi="selectedPoi" /> -->
              </gmap-info-window>
            </GmapMap>
          </div>
        </vs-row>
      </template>
    </vx-card>

    <div v-if="this.isGraphVisible" id="chart" class="p-2 rounded-lg bg-white w-full">
      <vs-tabs :color="tabColor" :value="tabIndex" class="h-full">
        <vs-tab v-if="getRolePermission().vehicle_details.periodic_track.show_speed" label="Speed" @click="
          () => {
            tabIndex = 0
            tabColor = 'danger'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <vue-apex-charts v-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="
          getRolePermission().vehicle_details.periodic_track.show_ignition
        " label="Ignition" @click="
          () => {
            tabIndex = 1
            tabColor = 'success'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <vue-apex-charts v-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="
          getRolePermission().vehicle_details.periodic_track.show_accu_voltage
        " label="Accu Voltage" @click="
          () => {
            tabIndex = 2
            tabColor = 'primary'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <vue-apex-charts v-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="getRolePermission().vehicle_details.periodic_track.show_fuel" label="Fuel" @click="
          () => {
            tabIndex = 3
            tabColor = 'warning'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <vue-apex-charts v-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
        <vs-tab v-if="getRolePermission().vehicle_details.periodic_track.show_temp" label="Temperature" @click="
          () => {
            tabIndex = 4
            tabColor = 'warning'
          }
        ">
          <div class="con-tab-ejemplo" style="min-height: 235px">
            <ul v-if="tempTab.length != 0" class="flex justify-end" style="gap: 10px">
              <li v-for="t in tempTab">
                <div class="flex flex-row items-center">
                  <label for="" class="mr-2">{{ t.name }}</label>
                  <vs-switch v-model="t.isActive" />
                </div>
              </li>
            </ul>
            <vue-apex-charts v-if="this.selectedLocation" type="area" :height="chartHeight" width="100%"
              :options="chartOptions" :series="series"></vue-apex-charts>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'

const car =
  'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
import 'firebase/database'
import circle from '../../assets/images/circle.png'
import half_arrow from '../../assets/images/half_arrow.png'
import circle_ijo from '../../assets/images/circle_ijo.png'
import circle_black from '../../assets/images/circle_black.png'
import circle_red from '../../assets/images/circle_red.png'
import periodic_overspeed from '../../assets/images/periodic_overspeed.png'
import periodic_harsh_brk from '../../assets/images/periodic_harsh_brk.png'
import periodic_harsh_acc from '../../assets/images/periodic_harsh_acc.png'
import periodic_mbcn from '../../assets/images/periodic_mbcn.png'
import periodic_crash from '../../assets/images/periodic_crash.png'
import periodic_geo_in from '../../assets/images/periodic_geo_in.png'
import periodic_geo_out from '../../assets/images/periodic_geo_out.png'
import periodic_default from '../../assets/images/periodic_default.png'
import periodic_overstay_on from '../../assets/images/periodic_overstay_on.png'
import periodic_overstay_off from '../../assets/images/periodic_overstay_off.png'

import * as REPO from '../../repository/index'
import { gmapApi } from 'vue2-google-maps'
import * as moment from 'moment'
import XLSX from 'xlsx'
import RangeSlider from 'vue-range-slider'
import VueApexCharts from 'vue-apexcharts'
// import 'vue-range-slider/dist/vue-range-slider.css'

import InfoWindow from '../components/InfoWindow.vue'
import RouteService from '../../route/RouteService'

const initialState = () => {
  return {
    isGraphVisible: false,
    series: [],
    chartOptions: {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'datetime',
        categories: [],
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm',
        },
      },
    },

    dataGroup: [],
    selectedData: {},
    isKnobHover: false,
    sliderValue: 50,
    sliderMaxValue: 100,
    disabledDates: {
      to: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDay() - 14
      ), // Disable all dates up to specific date
      from: new Date(), // Disable all dates after specific date
    },
    minStart: moment().subtract(3, 'months').format('YYYY-MM-DD HH:mm'),
    maxStart: moment().format('YYYY-MM-DD HH:mm'),
    center: { lat: -6.1498619, lng: 106.882887 },
    map: '',
    circle: circle,
    markers: [],
    response: [],
    directionsService: '',
    startLocation: {},
    endLocation: {},
    showMap: true,
    infoBoxOpen: false,
    selectedLocation: null,
    infoBoxPoiOpen: false,
    selectedPoi: null,
    calculated: false,
    directionsRenderer: '',
    location_list: [
      { lat: -6.167909, lng: 106.871585 },
      { lat: -6.170949, lng: 106.865867 },
      { lat: -6.17493, lng: 106.849967 },
      { lat: -6.152307, lng: 106.874697 },
      { lat: -6.149366, lng: 106.874697 },
    ],
    dateStart: null,
    date: null,
    overlay: true,
    step: 50,
    tick: 5,
    k: 0,
    kmStep: 0,
    baseSpeed: 8,
    zoomNow: 0,
    isResume: true,
    icon: null,
    lastVertex: 1,
    eol: null,
    maxEnd: null,
    dateEnd: null,
    marker: null,
    polyline: null,
    poly2: null,
    timerHandle: null,
    id: '',
    tabIndex: 0,
    tabColor: 'danger',
    chartHeight: 255,
    tempTab: [],

    trip: '',
    trips: [{ value: '', text: 'No Data' }],
    ritation_paths: [],
    userRole: null,
  }
}
export default {
  props: {
    license_plate: String,
    vehicle_category: String,
  },
  components: {
    RangeSlider,
    InfoWindow,
    VueApexCharts,
  },
  data: () => ({
    ...initialState(),
  }),
  computed: {
    google: gmapApi,
  },
  watch: {
    sliderValue(val) {
      // update kmStep based on sum of dataGroup distance from index 0 to val
      if (!this.dataGroup.length > 0) return
      let sum = 0

      for (let i = 0; i < val; i++) {
        sum += this.dataGroup[i].distance
      }
      this.kmStep = sum

      this.selectedLocation = this.response[val]
      this.map.panTo({
        lat: this.response[val].latitude,
        lng: this.response[val].longitude,
      })
      // this.map.setZoom(15)

      if (this.marker) {
        this.marker.setPosition({
          lat: this.response[val].latitude,
          lng: this.response[val].longitude,
        })
        if (!this.isResume) {
          this.icon.rotation = this.response[val].direction
        }
        this.marker.setIcon(this.icon)
      }
      const newX = new Date(
        this.toIsoString(new Date(this.response[val].device_time))
      ).getTime()
      this.chartOptions = {
        ...this.chartOptions,
        annotations: {
          xaxis: [
            {
              x: newX,
              borderColor: '#999',
              yAxisIndex: 0,
              label: {
                show: true,
                text: 'Rally',
                style: {
                  color: '#fff',
                  background: '#775DD0',
                },
              },
            },
          ],
        },
      }
    },
    tabIndex(val) {
      // clear tempTab if tab index is not 4
      if (val !== 4) {
        this.tempTab = []
      }

      if (val === 0) {
        this.series = [
          {
            name: 'Speed',
            data: this.response.map((x) => {
              return x.speed
            }),
            color: '#FF5E5D',
          },
        ]
      } else if (val === 1) {
        this.series = [
          {
            name: 'Ignition',
            data: this.response.map((x) => {
              return x.ignition
            }),
            color: '#00D68F',
          },
        ]
      } else if (val === 2) {
        this.series = [
          {
            name: 'Accu Voltage',
            data: this.response.map((x) => {
              return x.external_power_voltage
            }),
          },
        ]
      } else if (val === 3) {
        this.series = [
          {
            name: 'Fuel',
            data: this.response.map((x) => {
              return x.fuel_level_1_x
            }),
            color: '#FFA41B',
          },
        ]
      } else if (val === 4) {
        this.tempTab = [
          {
            name: 'Chiller Temp 1',
            key: 'dallas_temperature_1',
            data: this.response.map((x) => {
              return x.dallas_temperature_1
            }),
            color: '#FFA41B',
            isActive: true,
          },
          {
            name: 'Chiller Temp 2',
            key: 'dallas_temperature_2',
            data: this.response.map((x) => {
              return x.dallas_temperature_2
            }),
            color: '#FFA41B',
            isActive: true,
          },
        ]
      }
    },
    // dateStart(val) {
    //   this.dateEnd = null
    //   if (val != null) {
    //     //
    //     let tmp = moment(val).add(7, 'days').format('YYYY-MM-DD HH:mm')
    //     if (moment(tmp).isAfter(moment())) {
    //       this.maxEnd = moment().format('YYYY-MM-DD HH:mm')
    //     } else {
    //       this.maxEnd = tmp
    //     }
    //   }
    // },
    date(val) {
      this.dateStart = moment(val).format('YYYY-MM-DD 00:00:00')
      this.dateEnd = moment(val).format('YYYY-MM-DD 23:59:59')
      this.getTrips()
    },
  },
  created() {
    var self = this
  },
  beforeDestroy() {
    // REPO.unsubscribeVehicle(this.$route.params.id);
    //
  },
  methods: {
    getRouteFromOutside(date, id) {
      setTimeout(() => {
        this.date = date
      }, 500)
    },
    checkStatus(key, val) {
      let selected = JSON.parse(JSON.stringify(this.selectedLocation))
      //
      if (key in selected) {
        if (selected[key] == val) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    download_data() {
      var ProgressBar = require('progressbar.js')
      var bar = new ProgressBar.Line('#loading-container', {
        strokeWidth: 1,
        easing: 'easeInOut',
        duration: 1400,
        borderRadius: '10px',
        color: 'rgba(234, 84, 85, 1)',
        trailColor: '#eee',
        trailWidth: 1,
        svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
        text: {
          style: {
            color: '#999',
            position: 'absolute',
            right: '0',
            top: '30px',
            padding: 0,
            margin: 0,
            transform: null,
          },
          autoStyleContainer: false,
        },
        from: { color: '#FFEA82' },
        to: { color: '#ED6A5A' },
        step: (state, bar) => {
          bar.setText('Collecting Data ' + Math.round(bar.value() * 100) + ' %')
        },
      })

      bar.animate(0.0)
      this.loadingBtnStart('btn-download-1')
      const vid = this.$route.params.id
      const id = this.trip
      REPO.getRitaseDetail(
        vid,
        id
      ).then(async (res) => {
        const tmp = res.data.data.ritase
        // const temp = tmp.ritase.map((x, index) => {
        //   bar.animate(1.0)
        //   // return {
        //   //   'License Plate': x.license_plate,
        //   //   Alert: x.event_name,
        //   //   Ignition: x.ignition == 0 ? 'OFF' : 'ON',
        //   //   Speed: x.speed + ' Km/h',
        //   //   Direction: x.direction + '°',
        //   //   Date: x.device_time,
        //   //   'Driver Name': x.driver_name ? x.driver_name : '-',
        //   //   'Driver Phone': x.driver_phone ? x.driver_phone : '-',
        //   //   Gmaps: 'Show Google Map',
        //   //   Streetview: 'Show Street View',
        //   // }
        // })
        console.log(tmp)
        const rows = [tmp].map((x) => {
          return {
            license_plate: x.license_plate,
            fleet_group_name: x.fleet_group_name,
            geofence_out: x.geofence_out,
            geofence_in: x.geofence_in,
            poi_loading: x.poi_loading,
            track: [x.geofence_out, ...x.poi_loading, x.geofence_in],
            time_in: x.time_in,
            time_out: x.time_out,
            duration: x.duration,
            distance_travel: x.distance_travel,
          }
        })

        let ws;
        if (this.userRole.role_name != 'Customer') {

          const aoa = [
            [
              "License Plate", "Duration", "Distance Travel", "Fleet Group", "Name", "Latitude", "Longitude", "Time In", "Time Out", "Odometer", "Average Speed", "Max Speed", "Duration", "Distance Travel", "Travel Time", "Temperature 1", "Temperature 2", "Temperature 3", "Temperature 4"
            ],
          ];


          rows.forEach(row => {
            const maxRows = (row.track && row.track.length) || 1;

            for (let i = 0; i < maxRows; i++) {
              const track = row.track[i] || {};

             aoa.push([
                i === 0 ? row.license_plate : "",
                i === 0 ? this.getSimpleDurationV2(row.duration) : "",
                i === 0 ? row.distance_travel / 1000 + " Km" : "",
                i === 0 ? row.fleet_group_name : "",
                track.geofence_name || track.poi_name || track.geofence_name,
                track.latitude || "",
                track.longitude || "",
                i === maxRows - 1 ? track.device_time : track.time_in || "",
                i === 0 ? track.device_time : track.time_out || "",
                track.odometer || "",
                track.average_speed || "",
                track.max_speed || "",
                track.time_in && track.time_out ? this.getSimpleDurationV2(Math.floor((new Date(track.time_out) - new Date(track.time_in)) / 1000)) : "",
                track.distance_travel ? track.distance_travel / 1000 + " Km" : "",
                this.getSimpleDurationV2(track.travel_time) || "",
                track.dallas_temperature1 || "",
                track.dallas_temperature2 || "",
                track.dallas_temperature3 || "",
                track.dallas_temperature4 || "",
              ]);
            }
          });

          ws = XLSX.utils.aoa_to_sheet(aoa);
          // ws['!merges'] = [
          //   { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
          //   { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
          //   { s: { r: 0, c: 2 }, e: { r: 0, c: 15 } },
          //   { s: { r: 0, c: 16 }, e: { r: 0, c: 29 } },
          //   { s: { r: 0, c: 30 }, e: { r: 0, c: 44 } },
          //   { s: { r: 0, c: 45 }, e: { r: 1, c: 45 } },
          //   { s: { r: 0, c: 46 }, e: { r: 1, c: 46 } },
          //   { s: { r: 0, c: 47 }, e: { r: 1, c: 47 } },
          //   { s: { r: 0, c: 48 }, e: { r: 1, c: 48 } },
          // ];

        }

        if (this.userRole.role_name == 'Customer') {


          const aoa = [
            [
              "License Plate", "Duration", "Fleet Group", "Name", "Latitude", "Longitude", "Time In", "Time Out", "Duration", "Travel Time"
            ],
          ];


          rows.forEach(row => {
            const maxRows = (row.track && row.track.length) || 1;

            for (let i = 0; i < maxRows; i++) {
              const track = row.track[i] || {};

             aoa.push([
                i === 0 ? row.license_plate : "",
                i === 0 ? this.getSimpleDurationV2(row.duration) : "",
                i === 0 ? row.fleet_group_name : "",
                track.geofence_name || track.poi_name || track.geofence_name,
                track.latitude || "",
                track.longitude || "",
                i === maxRows - 1 ? track.device_time : track.time_in || "",
                i === 0 ? track.device_time : track.time_out || "",
                track.time_in && track.time_out ? this.getSimpleDurationV2(Math.floor((new Date(track.time_out) - new Date(track.time_in)) / 1000)) : "",
                this.getSimpleDurationV2(track.travel_time) || "",
              ]);
            }
          });

          ws = XLSX.utils.aoa_to_sheet(aoa);
          // ws['!merges'] = [
          //   { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
          //   { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
          //   { s: { r: 0, c: 2 }, e: { r: 0, c: 7 } },
          //   { s: { r: 0, c: 8 }, e: { r: 0, c: 13 } },
          //   { s: { r: 0, c: 14 }, e: { r: 0, c: 20 } },
          //   { s: { r: 0, c: 21 }, e: { r: 1, c: 21 } },
          //   { s: { r: 0, c: 22 }, e: { r: 1, c: 22 } },
          //   { s: { r: 0, c: 23 }, e: { r: 1, c: 23 } },
          // ];

        }

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Geofence Timeline");

        XLSX.writeFile(
          wb,
          `Ritase_${this.license_plate}_${moment().format('YYYY-MM-DD_HHmm')}.xlsx`,
          { bookType: 'xlsx', type: 'array' }
        );

        console.log(rows, "asdasdasd")
        // const worksheet = XLSX.utils.json_to_sheet(rows, { header: ["geofence_out", "geofence_in", "poi_loading", "alert"] })
        // for (let i = 0; i < rows.length; i++) {
        //   worksheet[`I${i + 2}`] = {
        //     v: 'Show Google Map',
        //     t: 's',
        //     l: {
        //       Target: `https://www.google.com/maps/search/?api=1&query=${tmp[i].latitude},${tmp[i].longitude}`,
        //       Tooltip: 'Show Google Map',
        //     },
        //     s: {
        //       font: {
        //         color: { rgb: '0563C1' },
        //         underline: true,
        //       },
        //     },
        //   }
        //   worksheet[`J${i + 2}`] = {
        //     v: 'Show Street View',
        //     t: 's',
        //     l: {
        //       Target: `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${tmp[i].latitude},${tmp[i].longitude}`,
        //       Tooltip: 'Show Street View',
        //     },
        //     s: {
        //       font: {
        //         color: { rgb: '0563C1' },
        //         underline: true,
        //       },
        //     },
        //   }
        // }
        // const workbook = XLSX.utils.book_new()
        // XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates')

        // XLSX.writeFile(
        //   workbook,
        //   `Ritase_${this.license_plate}_${moment().format(
        //     'YYYY-MM-DD_HHmm'
        //   )}.xlsx`,
        //   {
        //     compression: true,
        //     bookType: "xlsx",
        //     type: "array"
        //   }
        // )

        this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        this.$vs.loading.close('#isi_table > .con-vs-loading')
        this.loadingBtnStop('btn-download')
        this.load_done = true
        // destroy bar
        bar.destroy()
        this.loadingBtnStop('btn-download-1')
      })

      this.loadingBtnStop('btn-download-1')
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)
      //
      return tmp.data.data
    },
    format_number(val) {
      if (val) {
        let tmp = Math.round(val)
        return tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        return val
      }
    },
    startAnimation() {
      this.eol = this.polyline.Distance()
      this.map.setCenter(this.polyline.getPath().getAt(0))
      this.marker = new google.maps.Marker({
        position: this.polyline.getPath().getAt(0),
        map: this.map,
        icon: this.icon,
      })

      this.poly2 = new google.maps.Polyline({
        path: [this.polyline.getPath().getAt(0)],
        strokeColor: '#0000FF',
        strokeWeight: 10,
      })
      this.animate()
    },
    Timer(callback, delay, isResume = true) {
      var timerId,
        start,
        remaining = delay

      let pause = function () {
        window.clearTimeout(timerId)
        remaining -= Date.now() - start
      }

      let resume = function () {
        start = Date.now()
        window.clearTimeout(timerId)
        timerId = window.setTimeout(callback, remaining)
      }

      if (isResume) resume()
      else pause()
    },
    faster() {
      if (this.tick > 0) {
        this.baseSpeed = this.baseSpeed / 1.5
      }
    },
    slower() {
      this.baseSpeed = this.baseSpeed * 1.5
    },
    pauseAnimation() {
      this.isResume = false
    },
    resumeAnimation() {
      this.isResume = true
      this.map.setZoom(15)

      setTimeout(() => {
        this.animate()
      }, 500)
    },
    restartPlay() {
      this.sliderValue = 0
    },
    animate() {
      const self = this
      // this.kmStep = 0
      // let p = this.polyline.GetPointAtDistance(this.kmStep)

      const animateStep = () => {
        const data = self.dataGroup[this.sliderValue]
        //

        if (data) {
          const distance = data.distance
          const duration = data.duration * 5 // Adjust the duration if needed
          this.endLocation.latlng = new google.maps.LatLng(
            data.anchors[1].latitude,
            data.anchors[1].longitude
          )

          const animateSpeed = () => {
            var p = self.polyline.GetPointAtDistance(this.kmStep)
            let tmp = this.response.find((x) => {
              const latlng = new google.maps.LatLng(x.latitude, x.longitude)
              var distance =
                google.maps.geometry.spherical.computeDistanceBetween(p, latlng)

              if (x == data.anchors[1]) {
                // nothing to see here
              }
              return distance < 30 && x == data.anchors[1]
            })

            if (tmp) {
              if (data.speed == 0 && self.isResume) {
                // sleep for amount of duration and then continue
                setTimeout(() => {
                  this.map.panTo(this.endLocation.latlng)
                  this.sliderValue++
                  clearTimeout(this.timerHandle)
                  animateStep()
                }, duration)
              } else {
                this.map.panTo(this.endLocation.latlng)
                this.sliderValue++
                clearTimeout(this.timerHandle)
                animateStep()
              }
            } else {
              if (data.speed == 0 && self.isResume) {
                setTimeout(() => {
                  this.map.panTo(p)
                  this.sliderValue++
                  clearTimeout(this.timerHandle)
                  animateStep()
                }, 500)
              } else {
                this.step = data.speed * 2
                this.tick = (duration / (distance / this.step)) * this.baseSpeed
                const p = this.polyline.GetPointAtDistance(this.kmStep)
                this.map.panTo(p)
                const lastPosn = this.marker.getPosition()
                this.marker.setPosition(p)
                const heading = google.maps.geometry.spherical.computeHeading(
                  lastPosn,
                  p
                )
                this.icon.rotation = heading
                this.marker.setIcon(this.icon)
                this.kmStep += this.step
                this.timerHandle = new this.Timer(
                  () => {
                    animateSpeed(this.kmStep)
                  },
                  this.tick,
                  this.isResume
                )
              }
            }
          }

          animateSpeed()
        } else {
          // Animation completed
        }
      }

      // Start the animation
      animateStep()
    },
    clear(newState, isRerouting) {
      this.showMap = false
      let self = this
      setTimeout(() => {
        this.showMap = true
        this.$nextTick(() => {
          const body = isRerouting
            ? {
              ...initialState(),
              ...newState,
            }
            : initialState()

          Object.assign(this.$data, body)

          this.$refs.mapRef.$mapPromise
            .then((map) => {
              google.maps.event.addListener(map, 'zoom_changed', function () {
                // Determines map type and prevent illegal zoom levels
                //
                var zoom = map.getZoom()
                self.zoomNow = zoom
                //
              })
              this.map = map
              self.directionsService = new google.maps.DirectionsService()
              var rendererOptions = {
                polylineOptions: {
                  strokeColor: '#78a4ff',
                },
                map: map,
              }
              self.directionsDisplay = new google.maps.DirectionsRenderer(
                rendererOptions
              )

              self.icon = {
                path: car,
                scale: 0.7,
                strokeColor: 'white',
                strokeWeight: 0.1,
                fillOpacity: 1,
                fillColor: '#404040',
                offset: '5%',
                // rotation: parseInt(heading[i]),
                anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
              }
              google.maps.LatLng.prototype.distanceFrom = function (newLatLng) {
                var EarthRadiusMeters = 6378137.0 // meters
                var lat1 = this.lat()
                var lon1 = this.lng()
                var lat2 = newLatLng.lat()
                var lon2 = newLatLng.lng()
                var dLat = ((lat2 - lat1) * Math.PI) / 180
                var dLon = ((lon2 - lon1) * Math.PI) / 180
                var a =
                  Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                  Math.cos((lat1 * Math.PI) / 180) *
                  Math.cos((lat2 * Math.PI) / 180) *
                  Math.sin(dLon / 2) *
                  Math.sin(dLon / 2)
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
                var d = EarthRadiusMeters * c
                return d
              }

              google.maps.LatLng.prototype.latRadians = function () {
                return (this.lat() * Math.PI) / 180
              }

              google.maps.LatLng.prototype.lngRadians = function () {
                return (this.lng() * Math.PI) / 180
              }

              // === A method which returns the length of a path in metres ===
              google.maps.Polygon.prototype.Distance = function () {
                var dist = 0
                for (var i = 1; i < this.getPath().getLength(); i++) {
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                }
                return dist
              }

              // === A method which returns a GLatLng of a point a given distance along the path ===
              // === Returns null if the path is shorter than the specified distance ===
              google.maps.Polygon.prototype.GetPointAtDistance = function (
                metres
              ) {
                // some awkward special cases
                if (metres == 0) return this.getPath().getAt(0)
                if (metres < 0) return null
                if (this.getPath().getLength() < 2) return null
                var dist = 0
                var olddist = 0
                for (
                  var i = 1;
                  i < this.getPath().getLength() && dist < metres;
                  i++
                ) {
                  olddist = dist
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                }
                if (dist < metres) {
                  return null
                }
                var p1 = this.getPath().getAt(i - 2)
                var p2 = this.getPath().getAt(i - 1)
                var m = (metres - olddist) / (dist - olddist)
                return new google.maps.LatLng(
                  p1.lat() + (p2.lat() - p1.lat()) * m,
                  p1.lng() + (p2.lng() - p1.lng()) * m
                )
              }

              // === A method which returns an array of GLatLngs of points a given interval along the path ===
              google.maps.Polygon.prototype.GetPointsAtDistance = function (
                metres
              ) {
                var next = metres
                var points = []
                // some awkward special cases
                if (metres <= 0) return points
                var dist = 0
                var olddist = 0
                for (var i = 1; i < this.getPath().getLength(); i++) {
                  olddist = dist
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                  while (dist > next) {
                    var p1 = this.getPath().getAt(i - 1)
                    var p2 = this.getPath().getAt(i)
                    var m = (next - olddist) / (dist - olddist)
                    points.push(
                      new google.maps.LatLng(
                        p1.lat() + (p2.lat() - p1.lat()) * m,
                        p1.lng() + (p2.lng() - p1.lng()) * m
                      )
                    )
                    next += metres
                  }
                }
                return points
              }

              // === A method which returns the Vertex number at a given distance along the path ===
              // === Returns null if the path is shorter than the specified distance ===
              google.maps.Polygon.prototype.GetIndexAtDistance = function (
                metres
              ) {
                // some awkward special cases
                if (metres == 0) return this.getPath().getAt(0)
                if (metres < 0) return null
                var dist = 0
                var olddist = 0
                for (
                  var i = 1;
                  i < this.getPath().getLength() && dist < metres;
                  i++
                ) {
                  olddist = dist
                  dist += this.getPath()
                    .getAt(i)
                    .distanceFrom(this.getPath().getAt(i - 1))
                }
                if (dist < metres) {
                  return null
                }
                return i
              }
              // === Copy all the above functions to GPolyline ===
              google.maps.Polyline.prototype.Distance =
                google.maps.Polygon.prototype.Distance
              google.maps.Polyline.prototype.GetPointAtDistance =
                google.maps.Polygon.prototype.GetPointAtDistance
              google.maps.Polyline.prototype.GetPointsAtDistance =
                google.maps.Polygon.prototype.GetPointsAtDistance
              google.maps.Polyline.prototype.GetIndexAtDistance =
                google.maps.Polygon.prototype.GetIndexAtDistance
              self.polyline = new google.maps.Polyline({
                path: [],
                strokeColor: '#78a4ff',
                strokeWeight: 3,
              })
              self.poly2 = new google.maps.Polyline({
                path: [],
                strokeColor: '#78a4ff',
                strokeWeight: 3,
              })
              // this.directionsRenderer = new google.maps.DirectionsRenderer;
              // this.directionsRenderer.setMap(map);
            })
            .finally(() => {
              this.viewRoute()
            })
        })
      }, 1000)
      this.calculated = false
    },
    reroute() {
      const newState = {
        date: this.date,
        trips: this.trips,
        trip: this.trip,
      }
      this.clear(newState, true)
    },
    initSlider(max) {
      this.sliderValue = 0
      this.sliderMaxValue = max
    },
    toIsoString(date) {
      var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num) {
          return (num < 10 ? '0' : '') + num
        }

      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        'T' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds()) +
        '.000Z'
        // dif +
        // pad(Math.floor(Math.abs(tzo) / 60)) +
        // ':' +
        // pad(Math.abs(tzo) % 60)
      )
    },
    initChart() {
      //
      this.series = [
        {
          name: 'Speed',
          data: this.response.map((x) => {
            return x.speed
          }),
          color: '#FF5E5D',
        },
      ]

      const cat = this.response.map((x) => {
        return this.toIsoString(new Date(x.device_time))
      })

      this.chartOptions = {
        xaxis: {
          type: 'datetime',
          categories: cat,
        },
        annotations: {
          // yaxis: [
          //   {
          //     y: 50,
          //     borderColor: '#999',
          //     label: {
          //       show: true,
          //       text: 'Speed Limit',
          //       style: {
          //         color: '#fff',
          //         background: '#00E396',
          //       },
          //     },
          //   },
          // ],
          xaxis: [],
        },
      }
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    getTrips() {
      const self = this
      this.loadingBtnStart('selectTrip')
      const id = this.$route.params.id
      const start_date = moment(this.date).format('YYYY-MM-DD 00:00:00')
      const end_date = moment().format('YYYY-MM-DD 23:59:59')

      const param = {
        start_date: start_date,
        end_date: end_date,
      }
      //
      REPO.getRitase(id, param)
        .then((res) => {
          const tmp = res.data.data.data
          if (tmp.length == 0) {
            this.trips = [{ value: '', text: 'No Data' }]
            this.trip = ''
            return
          }
          this.trips = tmp.map((x, i) => {
            return { value: x._id, text: `Trip #${++i}` }
          })
          if (this.trip == '') {
            this.trip = this.trips[0].value
          }
        })
        .catch((err) => { })
        .finally(() => {
          this.loadingBtnStop('selectTrip')
        })
    },
    viewRoute() {
      this.loadingBtnStart('btn-load-1')
      this.loadingBtnStart('playback-map')
      var self = this
      this.isResume = true
      if (this.timerHandle) {
        clearTimeout(this.timerHandle)
      }
      if (this.marker) {
        this.marker.setMap(null)
      }

      this.polyline.setMap(null)
      this.poly2.setMap(null)
      this.directionsDisplay.setMap(null)
      this.polyline = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
      this.poly2 = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
      var rendererOptions = {
        polylineOptions: {
          strokeColor: '#78a4ff',
        },
        map: this.map,
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )

      const vid = this.$route.params.id
      const id = this.trip

      REPO.getRitaseDetail(vid, id).then((res) => {
        const tmp = res.data.data
        const data_jadi = tmp.playback
        const data_ritase = tmp.ritase

        this.response = data_jadi

        this.initSlider(data_jadi.length - 1)
        this.initChart()

        if (data_jadi.length > 0) {
          var stations = data_jadi.map((o) => {
            return { lat: o.latitude, lng: o.longitude, _id: o._id }
          })
          var poi_stations = data_ritase.poi_loading.map((o) => {
            return { lat: o.latitude, lng: o.longitude }
          })

          var parts = []
          var dataGroupTmp = []
          var max = 2
          let dataToMonitor = []
          const getAddressForGeofence = async (currentItem) => {
            data_ritase.latitude = currentItem.latitude
            data_ritase.longitude = currentItem.longitude
            this.$root.$emit('resolveRitationData', data_ritase)
          }
          data_jadi
            .map((currentItem, index, array) => {
              // Skip the last element to avoid going out of bounds
              if (index == 0) {
                getAddressForGeofence(currentItem)
              }
              if (index < array.length - 1) {
                const nextItem = array[index + 1]
                parts.push([
                  {
                    lat: currentItem.latitude,
                    lng: currentItem.longitude,
                  },
                  {
                    lat: nextItem.latitude,
                    lng: nextItem.longitude,
                  },
                ])
                const duration =
                  (new Date(nextItem.device_time).getTime() -
                    new Date(currentItem.device_time).getTime()) /
                  1000
                // const duration = 100
                dataGroupTmp.push({
                  anchors: [currentItem, nextItem],
                  speed:
                    google.maps.geometry.spherical.computeDistanceBetween(
                      new google.maps.LatLng(
                        currentItem.latitude,
                        currentItem.longitude
                      ),
                      new google.maps.LatLng(
                        nextItem.latitude,
                        nextItem.longitude
                      )
                    ) / duration,
                  duration: duration,
                })
              }

              return null
            })
            .filter((item) => item !== null)

          this.dataGroup = dataGroupTmp

          this.overlay = false
          // Show stations on the map as markers
          new google.maps.Marker({
            position: stations[0],
            map: self.map,
            icon: {
              url: circle_black,
              anchor: new google.maps.Point(10, 10),
              scaledSize: new google.maps.Size(20, 20),
              fillColor: '#00CCBB',
              fillOpacity: 1,
              strokeColor: '',
              strokeWeight: 0,
              labelOrigin: new google.maps.Point(10, 30),
            },
            label: {
              text: 'Start',
              color: 'black',
              fontSize: '12px',
              fontWeight: 'bold',
              backgroundColor: 'black',
              labelClass: 'startendmarker',
            },
          })
          new google.maps.Marker({
            position: stations[stations.length - 1],
            map: self.map,
            icon: {
              url: circle_black,
              anchor: new google.maps.Point(10, 10),
              scaledSize: new google.maps.Size(20, 20),
              fillColor: '#00CCBB',
              fillOpacity: 1,
              strokeColor: '',
              strokeWeight: 0,
              labelOrigin: new google.maps.Point(10, 30),
            },
            label: {
              text: 'Stop',
              color: 'black',
              fontSize: '12px',
              fontWeight: 'bold',
              backgroundColor: 'black',
              labelClass: 'startendmarker',
            },
          })

          for (let i = 0; i < poi_stations.length; i++) {
            new google.maps.Marker({
              position: poi_stations[0],
              map: self.map,
              icon: {
                url: circle_black,
                anchor: new google.maps.Point(10, 10),
                scaledSize: new google.maps.Size(20, 20),
                fillColor: '#00CCBB',
                fillOpacity: 1,
                strokeColor: '',
                strokeWeight: 0,
                labelOrigin: new google.maps.Point(10, 30),
              },
              label: {
                text: data_ritase.poi_loading[i].poi_name,
                color: 'black',
                fontSize: '12px',
                fontWeight: 'bold',
                backgroundColor: 'black',
                labelClass: 'startendmarker',
              },
            })
          }

          const pois = data_ritase.poi_loading

          for (let I = 0; I < pois.length; I++) {
            const element = pois[I]
            const loc = {
              lat: element.latitude,
              lng: element.longitude,
            }
            let color = '#FF0000'
            new google.maps.Circle({
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.15,
              center: loc,
              map: self.map,
              radius: element.radius ? element.radius : 20,
            })
            const poiMark = new google.maps.Marker({
              position: loc,
              map: self.map,
              icon: {
                url: periodic_geo_in,
                anchor: new google.maps.Point(15, 50),
                scaledSize: new google.maps.Size(30, 43),
                fillColor: '#131B87',
                fillOpacity: 1,
                strokeColor: '#131B87',
                strokeWeight: 5,
                labelOrigin: new google.maps.Point(10, -10),
              },
              label: {
                text: element.poi_name,
                color: 'black',
                fontSize: '12px',
                fontWeight: 'bold',
                backgroundColor: 'black',
                labelClass: 'startendmarker',
              },
            })
            google.maps.event.addListener(poiMark, 'click', () => {
              // self.infoBoxOpen = false
              self.infoBoxPoiOpen = true
              self.selectedPoi = element
            })
          }

          for (var i = 0; i < stations.length; i++) {
            let mark = null
            let mark2 = null

            if (data_jadi[i].event_type != 'SAMPLING') {
              let alert_icon = null
              switch (data_jadi[i].event_type) {
                case 'OVERSPEED':
                  alert_icon = periodic_overspeed
                  break

                case 'HARSH_BRK':
                  alert_icon = periodic_harsh_brk
                  break

                case 'HARSH_ACC':
                  alert_icon = periodic_harsh_acc
                  break

                case 'MB_CN':
                  alert_icon = periodic_mbcn
                  break

                case 'CRASH':
                  alert_icon = periodic_crash
                  break

                case 'GEOFENCE_IN':
                  alert_icon = periodic_geo_in
                  break

                case 'GEOFENCE_OUT':
                  alert_icon = periodic_geo_out
                  break

                case 'OVERSTAY_ENGINE_ON':
                  alert_icon = periodic_overstay_on
                  break

                case 'OVERSTAY_ENGINE_OFF':
                  alert_icon = periodic_overstay_off
                  break

                default:
                  alert_icon = periodic_default
                  break
              }
              // alert_icon = periodic_default

              mark = new google.maps.Marker({
                position: stations[i],
                map: self.map,
                icon: {
                  url: alert_icon,
                  anchor: new google.maps.Point(15, 50),
                  scaledSize: new google.maps.Size(30, 43),
                  fillColor: '#131B87',
                  fillOpacity: 1,
                  strokeColor: '#131B87',
                  strokeWeight: 5,
                },
              })

              mark2 = new google.maps.Marker({
                position: stations[i],
                map: self.map,
                icon: {
                  url: circle_red,
                  // path: 'M10 9L5.08772 0L0 9L5.08772 7.41177L10 9Z',
                  anchor: new google.maps.Point(5, 5),
                  scaledSize: new google.maps.Size(10, 10),
                  fillColor: '#131B87',
                  fillOpacity: 1,
                  strokeColor: '',
                  strokeWeight: 0,
                  // rotation: parseInt(data_jadi[i].direction),
                },
              })
            } else {
              // return
              mark = new google.maps.Marker({
                position: stations[i],
                map: self.map,
                icon: {
                  url: circle,
                  // path: 'M10 9L5.08772 0L0 9L5.08772 7.41177L10 9Z',
                  anchor: new google.maps.Point(5, 5),
                  scaledSize: new google.maps.Size(10, 10),
                  fillColor: '#131B87',
                  fillOpacity: 1,
                  strokeColor: '',
                  strokeWeight: 0,
                  rotation: parseInt(data_jadi[i].direction),
                },
              })
              // mark = null
              continue
            }

            let mark_tmp = stations[i]
            google.maps.event.addListener(mark, 'click', () => {
              //
              //
              self.infoBoxOpen = false
              // //
              this.sliderValue = this.response.findIndex((x) => {
                return x._id == mark_tmp._id
              })

              self.$vs.loading()
              REPO.getOneDetail(mark_tmp._id)
                .then((rress) => {
                  self.$vs.loading.close()
                  self.selectedLocation = rress.data.data
                  self.selectedLocation.latitude = mark_tmp.lat
                  self.selectedLocation.longitude = mark_tmp.lng
                  self.infoBoxOpen = true
                })
                .catch((err) => {
                  self.$vs.loading()
                })
            })
            if (mark2) {
              google.maps.event.addListener(mark2, 'click', () => {
                //
                self.infoBoxOpen = false
                // //
                this.sliderValue = this.response.findIndex((x) => {
                  return x._id == mark_tmp._id
                })

                self.$vs.loading()
                REPO.getOneDetail(mark_tmp._id)
                  .then((rress) => {
                    self.$vs.loading.close()
                    self.selectedLocation = rress.data.data
                    self.selectedLocation.latitude = mark_tmp.lat
                    self.selectedLocation.longitude = mark_tmp.lng
                    self.infoBoxOpen = true
                  })
                  .catch((err) => {
                    self.$vs.loading()
                  })
              })
            }
          }

          const routeService = new RouteService(
            self.map,
            self.polyline,
            self.dataGroup,
            parts,
            self.vehicle_category
          )
          routeService.setCallbacks({
            onComplete: (result) => {
              self.startAnimation()
              self.loadingBtnStop('playback-map')
            },
            onError: (error) => {
              self.loadingBtnStop('playback-map')
              // console.error(error)
            },
          })

          routeService.processRoutes()

          this.loadingBtnStop('btn-load-1')
          this.calculated = true
        } else {
          this.loadingBtnStop('btn-load-1')
          this.loadingBtnStop('playback-map')
        }
      })
    },
  },

  mounted() {
    this.userRole = JSON.parse(localStorage.getItem('userRole'));
    let self = this
    //
    this.id = this.license_plate
    this.date = moment().format('YYYY-MM-DD')
    //
    // this.$refs.mapRef.$mapPromise.then((map) => {
    //   this.map = map
    // })
    this.$refs.mapRef.$mapPromise.then((map) => {
      google.maps.event.addListener(map, 'zoom_changed', function () {
        // Determines map type and prevent illegal zoom levels
        //
        var zoom = map.getZoom()
        self.zoomNow = zoom
        //
      })
      //

      this.map = map
      self.directionsService = new google.maps.DirectionsService()
      var rendererOptions = {
        polylineOptions: {
          strokeColor: '#78a4ff',
        },
        map: map,
      }
      self.directionsDisplay = new google.maps.DirectionsRenderer(
        rendererOptions
      )

      self.icon = {
        path: car,
        scale: 0.7,
        strokeColor: 'white',
        strokeWeight: 0.1,
        fillOpacity: 1,
        fillColor: '#404040',
        offset: '5%',
        // rotation: parseInt(heading[i]),
        anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
      }
      google.maps.LatLng.prototype.distanceFrom = function (newLatLng) {
        var EarthRadiusMeters = 6378137.0 // meters
        var lat1 = this.lat()
        var lon1 = this.lng()
        var lat2 = newLatLng.lat()
        var lon2 = newLatLng.lng()
        var dLat = ((lat2 - lat1) * Math.PI) / 180
        var dLon = ((lon2 - lon1) * Math.PI) / 180
        var a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos((lat1 * Math.PI) / 180) *
          Math.cos((lat2 * Math.PI) / 180) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = EarthRadiusMeters * c
        return d
      }

      google.maps.LatLng.prototype.latRadians = function () {
        return (this.lat() * Math.PI) / 180
      }

      google.maps.LatLng.prototype.lngRadians = function () {
        return (this.lng() * Math.PI) / 180
      }

      // === A method which returns the length of a path in metres ===
      google.maps.Polygon.prototype.Distance = function () {
        var dist = 0
        for (var i = 1; i < this.getPath().getLength(); i++) {
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
        }
        return dist
      }

      // === A method which returns a GLatLng of a point a given distance along the path ===
      // === Returns null if the path is shorter than the specified distance ===
      google.maps.Polygon.prototype.GetPointAtDistance = function (metres) {
        // some awkward special cases
        if (metres == 0) return this.getPath().getAt(0)
        if (metres < 0) return null
        if (this.getPath().getLength() < 2) return null
        var dist = 0
        var olddist = 0
        for (var i = 1; i < this.getPath().getLength() && dist < metres; i++) {
          olddist = dist
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
        }
        if (dist < metres) {
          return null
        }
        var p1 = this.getPath().getAt(i - 2)
        var p2 = this.getPath().getAt(i - 1)
        var m = (metres - olddist) / (dist - olddist)
        return new google.maps.LatLng(
          p1.lat() + (p2.lat() - p1.lat()) * m,
          p1.lng() + (p2.lng() - p1.lng()) * m
        )
      }

      // === A method which returns an array of GLatLngs of points a given interval along the path ===
      google.maps.Polygon.prototype.GetPointsAtDistance = function (metres) {
        var next = metres
        var points = []
        // some awkward special cases
        if (metres <= 0) return points
        var dist = 0
        var olddist = 0
        for (var i = 1; i < this.getPath().getLength(); i++) {
          olddist = dist
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
          while (dist > next) {
            var p1 = this.getPath().getAt(i - 1)
            var p2 = this.getPath().getAt(i)
            var m = (next - olddist) / (dist - olddist)
            points.push(
              new google.maps.LatLng(
                p1.lat() + (p2.lat() - p1.lat()) * m,
                p1.lng() + (p2.lng() - p1.lng()) * m
              )
            )
            next += metres
          }
        }
        return points
      }

      // === A method which returns the Vertex number at a given distance along the path ===
      // === Returns null if the path is shorter than the specified distance ===
      google.maps.Polygon.prototype.GetIndexAtDistance = function (metres) {
        // some awkward special cases
        if (metres == 0) return this.getPath().getAt(0)
        if (metres < 0) return null
        var dist = 0
        var olddist = 0
        for (var i = 1; i < this.getPath().getLength() && dist < metres; i++) {
          olddist = dist
          dist += this.getPath()
            .getAt(i)
            .distanceFrom(this.getPath().getAt(i - 1))
        }
        if (dist < metres) {
          return null
        }
        return i
      }
      // === Copy all the above functions to GPolyline ===
      google.maps.Polyline.prototype.Distance =
        google.maps.Polygon.prototype.Distance
      google.maps.Polyline.prototype.GetPointAtDistance =
        google.maps.Polygon.prototype.GetPointAtDistance
      google.maps.Polyline.prototype.GetPointsAtDistance =
        google.maps.Polygon.prototype.GetPointsAtDistance
      google.maps.Polyline.prototype.GetIndexAtDistance =
        google.maps.Polygon.prototype.GetIndexAtDistance
      self.polyline = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
      self.poly2 = new google.maps.Polyline({
        path: [],
        strokeColor: '#78a4ff',
        strokeWeight: 3,
      })
    })

    this.$root.$on('populateFromParent', (tr) => {
      this.trip = tr.id
      this.date = moment(tr.date).format('YYYY-MM-DD')
      setTimeout(() => {
        this.viewRoute()
        //
      }, 1000)
    })

    this.getTrips()
  },
}
</script>

<style lang="scss">
$rail-fill-color: #ff1111;

@import '~vue-range-slider/dist/vue-range-slider.scss';

.datetimepicker>.flex {
  display: none !important;
}

.visible>.flex {
  display: block !important;
  left: 0;
}

.date-popup>.vs-popup>.vs-popup--content {
  overflow: visible;
}

.con-slot-tabs {
  height: calc(100% - 38px);

  .con-tab {
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>
.control-place {
  position: absolute;
  z-index: 2;
  bottom: 3px;
  // bottom: -10px;
  // left: 50%;
  // transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  width: calc(100% - 60px);

  .controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
}

.control-side {
  position: absolute;
  z-index: 3;
  bottom: 150px;
  right: 10px;
  transform: translateY(50%);
  display: flex;
  flex-direction: column;

  .controls {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
}

.startendmarker {
  background-color: black;
  border-radius: 5px;
  padding: 5px;
  color: black;
  // font-weight: bold;
  // font-size: 12px;
}

.tooltip-top {
  position: absolute;
  top: -30px;
  left: -10px;
  background: #ff1111;
  color: white;
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
}

.control-btn {
  background: linear-gradient(30deg, #d23030 0%, #f89595 100%);
  border-radius: 50%;
  margin: 10px;
  font-size: 12px;
  color: white;
  width: 30px;
  font-weight: bold;
  cursor: pointer;
  height: 30px;
  padding-left: 8px;
  padding-top: 7px;
  box-shadow: 2px 3px 4px dimgrey;
}

.buletan {
  float: left;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-top: 3px;
  margin-right: 6px;
}

.biru {
  background: blue;
}

.merah {
  background: red;
}

.item {
  background: black;
}

.ijo {
  background: green;
}

input {
  border: 2px solid #1489da;
}

.datetimepicker>.flex {
  display: none !important;
}

.visible>.flex {
  display: flex !important;
}

.date-popup>.vs-popup>.vs-popup--content {
  overflow: visible;
}

.heights {
  width: 100%;
  height: calc(100vh - 16.5rem);
}

.legenda {
  box-shadow: -2px 2px 4px #97b5ca;
  padding: 5px;
  right: 0;
  font-size: 12px;
  width: 150px;
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 7px;
}

.grab:hover {
  cursor: n-resize;
}

// div.gmnoprint {
//   z-index: 6 !important;
// }</style>
